import { AppItem } from '@tt4b/ttam-enums';

export type DataItem = AppItem & {
  name: string;
  desc: string;
  icon: string;
  img: string;
  disabled: boolean;
};

export enum SAN_STATUS {
  NotEnableOnMMP = 3, // 没有配置san
  ForExempt = 6, // 在豁免名单
}
